import { render, staticRenderFns } from "./phoneSolution.vue?vue&type=template&id=d4d68ab4&scoped=true"
import script from "./phoneSolution.vue?vue&type=script&lang=js"
export * from "./phoneSolution.vue?vue&type=script&lang=js"
import style0 from "./phoneSolution.vue?vue&type=style&index=0&id=d4d68ab4&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d68ab4",
  null
  
)

export default component.exports